import { render, staticRenderFns } from "./Rekomendasi_izin_praktik_detail.vue?vue&type=template&id=15c96967&"
import script from "./Rekomendasi_izin_praktik_detail.vue?vue&type=script&lang=js&"
export * from "./Rekomendasi_izin_praktik_detail.vue?vue&type=script&lang=js&"
import style0 from "./Rekomendasi_izin_praktik_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports